import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DashboardCard } from "../dashboardCard";
import { getNavigationLinks } from "../../utils/common";
import { triggerShowHeader } from "../../redux/actions/action";
import { useHistory, useLocation } from "react-router-dom";
import ActionAlert from "../actionAlert";
import Footer from "../Footer";

export default function CustomLandingBody(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const {
    filterValue: { selectedPartnerRoleName },
  } = useSelector((state) => state.homeReducer);

  const { tilesData } = useSelector((state) => state.homeReducer);

  const currentYear = new Date().getFullYear();
  let navigationLinks =
    tilesData &&
    tilesData.data &&
    tilesData.data.content &&
    getNavigationLinks(selectedPartnerRoleName, tilesData.data.content);
  const partnerRoleType = useSelector(
    (state) => state.homeReducer.partnerRoleType,
  );

  const [showAlert, setShowAlert] = useState(false);
  const [alertDashboardName, setAlertDashboardName] = useState(null);

  useEffect(() => {
    const fetchData = () => {
      return dispatch(triggerShowHeader(false));
    };

    if (props.showAlert === true) {
      history.push({
        pathname: "/",
        state: {
          showAlert: props.showAlert,
          alertDashboardName: props.dashboardName,
        },
      });
    }

    setAlertDashboardName(location?.state?.alertDashboardName);
    setShowAlert(location?.state?.showAlert);

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showAlert && (
        <ActionAlert
          showAlert={showAlert}
          setShowAlert={setShowAlert}
          alertDashboardName={alertDashboardName}
        />
      )}
      <div className="innercontdiv">
        <div className="container-fluid">
          <div className="row" data-cy="tiles-wrapper">
            {navigationLinks
              ? navigationLinks.map((item, index) => {
                  return (
                    <DashboardCard
                      key={index}
                      id={item.route}
                      text={item.name}
                      icon={item.icon}
                      index={index}
                      partnerRoleType={partnerRoleType}
                    />
                  );
                })
              : ""}
          </div>
        </div>
        <Footer />
        {/* <footer
          className="wow fadeInUp fixed-bottom"
          data-wow-delay="2.3s"
          data-wow-duration="0.7s"
        >
          &copy; {currentYear} Reliance Industries Limited. All rights reserved.
        </footer> */}
      </div>
    </>
  );
}
